import React from "react";

const navItems = [
  { href: "#about", label: "About", icon: "👨🏻‍💻" },
  { href: "#narrative", label: "Narrative", icon: "🧭" },
  { href: "#background", label: "Background", icon: "🌏" },
  { href: "#impact", label: "Impact", icon: "📈" },
  { href: "#fit", label: "Fit", icon: "🤝" },
  { href: "#case-studies", label: "Case Studies", icon: "🧩" },
  { href: "#skills", label: "Skills", icon: "🛠️" },
  { href: "#education", label: "Education", icon: "🎓" },
];

const Nav = () => {
  return (
    <nav className="nav mt-8 hidden lg:block" aria-label="Primary navigation">
      <ul className="space-y-1">
        {navItems.map((item) => (
          <li key={item.href}>
            <a
              className="group flex w-64 items-center gap-3 rounded-md px-3 py-2 transition hover:bg-white/80 hover:shadow-sm focus-visible:bg-white/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-300"
              href={item.href}
            >
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-[rgb(250,250,250)] text-sm transition group-hover:border-slate-400 group-hover:bg-white group-focus-visible:border-slate-400 group-focus-visible:bg-white">
                {item.icon}
              </span>
              <span className="nav-text text-xs font-bold uppercase tracking-widest text-slate-500 transition group-hover:text-slate-950 group-focus-visible:text-slate-950">
                {item.label}
              </span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Nav;
